<img
  *ngIf="src"
  [src]="src"
  [alt]="alt"
  [class]="classes"
  (load)="onImageLoad()"
  (error)="onImageError()"
/>
